<template>
  <v-form ref="documentForm">
    <v-card-text>
      <v-layout wrap>
        <v-btn color="error" @click="deleteDocument">Delete</v-btn>

        <v-flex xs12>
          <v-text-field
            label="Display Name"
            outline
            tabindex="1"
            v-model="form.display_name"
            name="display_name"
            :hide-details="!errors.has('display_name')"
            :error="errors.has('display_name')"
            :error-count="errors.count('display_name')"
            :error-messages="errors.get('display_name')"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-autocomplete
            label="Categories"
            v-model="form.categories"
            name="categories"
            cache-items
            :loading="loading"
            :search-input.sync="search"
            :items="categories"
            placeholder="Select Categories"
            item-text="name"
            item-value="id"
            height="35"
            browser-autocomplete="disabled"
            multiple
            hide-details
            small-chips
            dense
            flat
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12>
          <v-autocomplete
            v-model="form.permission_groups"
            item-text="name"
            item-value="id"
            :items="permissionGroups"
            label="Permission Groups"
            placeholder="Select Permission Groups"
            height="35"
            multiple
            hide-details
            :small-chips="$vuetify.breakpoint.smAndUp"
            dense
            flat
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-btn xs12 @click="secondaryAction">
        {{
        secondaryActionText
        }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn xs12 color="primary" @click="submit">{{ submitText }}</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
  data() {
    return {
      search: "",
      loading: false,
      document: false,
      categories: [],
      form: {
        display_name: "",
        categories: [],
        permission_groups: []
      },
      errors: new Errors()
    };
  },

  computed: {
    ...mapGetters("document_center", [
      "selectedDocument",
      "selectedCategory",
      "permissionGroups"
    ]),

    secondaryActionText() {
      return this.document ? "Cancel" : "Reset";
    },

    submitText() {
      return this.document ? "Save Changes" : "Create Document";
    },

    documentId() {
      return this.$route.params.id;
    }
  },

  methods: {
    ...mapActions("document_center", {
      UPDATE_DOCUMENT: "updateDocument",
      DELETE_DOCUMENT: "deleteDocument",
      GET_DOCUMENT: "getDocument",
      GET_CATEGORIES: "getCategories"
    }),

    secondaryAction() {
      this.$refs.documentForm.reset();
      this.errors.clear();

      if (this.document) {
        const category = (this.document.categories || [])[0];
        if (category) {
          this.$router.push(
            `/admin/categories/${category.url_slug}/document/${this.document.id}`
          );
        }
      } else {
        this.$router.back();
      }
    },

    submit() {
      this.UPDATE_DOCUMENT({
        form: this.form,
        id: this.document.id
      })
        .then(data => {
          this.$set(this, "document", data);

          return data;
        })
        .catch(error => {
          error = Object.assign({}, error);
          this.errors.record(error.response.data.errors);
        });
    },

    deleteDocument() {
      this.$swal({
        title: "Are you sure?",
        text: "This will delete the file associated with other categories!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          const payload = {
            document_id: this.document.id
          };

          this.DELETE_DOCUMENT(payload).then(data => {
            if (data.success) {
              this.$router.replace(`/admin/categories/${category.url_slug}`);
            }
          });
        }
      });
    },

    setDocument(document) {
      this.$set(this, "document", document);

      _.forIn(this.form, (value, key) => {
        value = document[key];

        if (key === "categories" || key === "permission_groups") {
          value = _.map(value, "id");
        }

        if (value) {
          this.$set(this.form, key, value);
        }
      });
    },

    getCategories: _.debounce(function() {
      this.loading = true;

      let payload = { admin: true };

      if (this.search) {
        payload.search = this.search;
      } else {
        payload.topLevel = true;
      }

      this.GET_CATEGORIES(payload)
        .then(({ data }) => {
          const categories = this.getFullCategoryNames([
            this.selectedCategory,
            ...data
          ]);

          let count = 0;
          while (count < categories.length) {
            this.$set(
              this,
              "categories",
              _.slice(categories, count, (count += 100))
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }, 100),

    getFullCategoryNames(categories) {
      return categories.map(category => {
        const names = [category.name];

        let parent = category.parent;
        while (parent) {
          names.unshift(parent.name);
          parent = parent.parent;
        }

        return {
          ...category,
          name: names.join(" -> ")
        };
      });
    }
  },

  created() {
    const selectedDocument = this.selectedDocument(this.documentId);
    if (selectedDocument) {
      this.setDocument(selectedDocument);
    } else {
      this.$set(this.form, "categories", [this.selectedCategory.id]);
    }

    this.$set(this, "categories", [this.selectedCategory]);
  },

  watch: {
    search(value, oldValue) {
      if (value !== oldValue && value !== null && value.length >= 3) {
        this.getCategories();
      }
    }
  }
};
</script>
